export default function Title(props) {
    return (
        <div>
            <h1>
                {props.mainTitle}
            </h1>
        </div>
    )
}